import { AppDataActions } from '../../redux/app-data';
import { getTopicsToSubscribe } from './push-api-configs';
import Socket from './kambi-push-api';
import Global from '../../global';
import Mock from './mock-messages';

export default function getPushApiCallbacks(store, logData) {
  let options = {
    onConnect: function () {
      Global.logger.info(`SOCKET CONNECTED for context ${JSON.stringify(logData)}`);

      Mock.exposeMock();
    },
    onDisconnect: function () {
      Global.logger.error(`SOCKET DISCONNECTED for context ${JSON.stringify(logData)}`);
    },
    onReconnect: function (attemptNumber) {
      Global.logger.warn(`SOCKET RECONNECTED (attempt ${attemptNumber}) for context ${JSON.stringify(logData)}`);

      const SocketClient = Socket.getInstance(/*options*/);
      const topics = getTopicsToSubscribe(store.getState());
      SocketClient.subscribeToTopics(topics);

    },
    onError: function (error) {
      Global.logger.error(`SOCKET ERROR ${error} for context ${JSON.stringify(logData)}`);
    },
    onReconnectAttempt: function (attemptNumber) {
      Global.logger.warn(`SOCKET RECONNECT ATTEMPT ${attemptNumber} for context ${JSON.stringify(logData)}`);
    },
    onMessage: function (data) {
      const messageInfo = JSON.parse(data);
      store.dispatch(AppDataActions.processMessagesFromWS(messageInfo));
    },
    useProdApis: store.getState().appConfig.useProdApis
  };

  return options;
}
